import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'FrkDivider',
  props: {
  text: {
    type: String,
    default: '',
  },
  small: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



return { __sfc: true, }
}

})